import React, { useEffect,useState } from 'react';
import * as CONSTANTS from "../../CONSTANTS";
import axios from 'axios';
import { Link } from 'react-router-dom';

function CitiesBlock() {

  const [listCities, setListCities]                                                   = useState([]);

  useEffect(() => {
    collectRandomCities();
  },[])

  const collectRandomCities = async () => {
    try{

      const content = await axios.get(CONSTANTS.API_URL + "tours/cities/random/v1", {
            headers: {
                api_key: CONSTANTS.TOKEN_APIKEY
            }
        });

   
      setListCities(content.data)
    }catch(err){
      console.log(err);
    }

  }
  return (
    <div className="content-section home-area">
        <div className="container standard-tour-list">
           <h2>Cities</h2>
           <p className="txt-shade">Some of our most popular cities</p>
           {
            listCities &&
            listCities.length > 0 &&(
              <div className="row-box-cities">
                {
                  listCities.map((city, index) => {
                    return index === 0 ?
                      <div className="left-start"  key={index}>
                       <div className={"item-city it-c" + index} >
                               <div className="imag-base-city" style={{ 
                                      backgroundImage: `url("${city.img_url}")` 
                                    }}>
                                    <Link 
                                        className="link-white"
                                        to={"/shop?city=" +city.title}>
                                      <h4>{city.title}</h4>
                                   </Link>
                                </div>
                          </div>
                        </div>
                          :
                           <div className={"item-city it-c" + index} key={index} >
                               <div className="imag-base-city" style={{ 
                                      backgroundImage: `url("${city.img_url}")` 
                                    }}>
                                   <Link 
                                    className="link-white"
                                    to={"/shop?city=" +city.title}>
                                   <h4>{city.title}</h4>
                                   </Link>
                                </div>
                          </div>
                  })
                }
              </div>
            )
           }
        </div>
    </div>
  )
}

export default CitiesBlock